export default () => {
    return [
        {
            path: '/transactions',
            name: 'transactions',
            component: () => import('./views/transactions.vue'),
        },
    ];
};
